import { GET_BYBETJENTGRUPPER_URL } from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "BYBETJENTGRUPPER";

export function getBybetjentGrupper() {
  return axiosUtils.GetAll(GET_BYBETJENTGRUPPER_URL, actionType);
}
